export default __webpack_public_path__ + "static/media/compose-Messaage.abbb4256.svg";